// ***********************************
// Pricing.vue
// July 2019 - adhoc page to load new pricing info
// ***********************************
<template>
  <div id="app">
    <div class="container">
      

      
      <b-form  @reset="onReset">

        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            Price Loader
          </b-card-header>

            <b-card-body>

              <div>
                <b-button
                  v-on:click="getShapeAttributes"
                  type="button"
                  v-b-tooltip.hover
                  title="Compare/Contrast shape attributes."
                  block
                  variant="outline-primary"
                >Compare/Contrast shape attributes.</b-button>
                <br>
              </div>
              
              <b-form-group label="AWS Region:" label-cols="3" label-size="sm">
                <!--@change="showCalculateMessage"-->
                <b-form-select v-model="regionCode" size="sm" :options="region_lov"/>
                  <!--<option value= "af-south-1">af-south-1 </option>-->
                  <!--<option value= "ap-east-1">ap-east-1 </option>-->
                  <!--<option value= "ap-northeast-1">ap-northeast-1 </option>-->
                  <!--<option value= "ap-northeast-2">ap-northeast-2 </option>-->
                  <!--<option value= "ap-northeast-3">ap-northeast-3 </option>-->
                  <!--<option value= "ap-south-1">ap-south-1 </option>-->
                  <!--<option value= "ap-southeast-1">ap-southeast-1 </option>-->
                  <!--<option value= "ap-southeast-2">ap-southeast-2 </option>-->
                  <!--<option value= "ap-southeast-3">ap-southeast-3 </option>-->
                  <!--<option value= "ca-central-1">ca-central-1 </option>-->
                  <!--<option value= "eu-central-1">eu-central-1 </option>-->
                  <!--<option value= "eu-north-1">eu-north-1 </option>-->
                  <!--<option value= "eu-south-1">eu-south-1 </option>-->
                  <!--<option value= "eu-west-1">eu-west-1 </option>-->
                  <!--<option value= "eu-west-2">eu-west-2 </option>-->
                  <!--<option value= "eu-west-3">eu-west-3 </option>-->
                  <!--<option value= "me-south-1">me-south-1 </option>-->
                  <!--<option value= "sa-east-1">sa-east-1 </option>-->
                  <!--<option value= "us-east-1">us-east-1 </option>-->
                  <!--<option value= "us-east-2">us-east-2 </option>-->
                  <!--<option value= "us-gov-east-1">us-gov-east-1 </option>-->
                  <!--<option value= "us-gov-west-1">us-gov-west-1 </option>-->
                  <!--<option value= "us-west-1">us-west-1 </option>-->
                  <!--<option value= "us-west-2">us-west-2 </option>-->

              </b-form-group>

              <div>
                <b-button
                  v-on:click="getPricingRegion"
                  type="button"
                  v-b-tooltip.hover
                  title="Retrieve Latest Pricing for above region."
                  block
                  variant="outline-primary"
                >Retrieve Latest Pricing for above region.</b-button>
                <br>
              </div>
              
              <div>
              <b-alert :show="showAlertRecalc" :variant="alertStyleRecalc">{{alertTextRecalc}}</b-alert>
              <b-alert :show="showCalculateMessageFlag" variant="danger">Please click on one of the above buttons.</b-alert>
                
              <div>
                <b-button
                  v-on:click="scanDates"
                  type="button"
                  block
                  variant="outline-primary"
                >Scan Last Update Dates.</b-button>
                <br>
              </div>
              <div>
                <b-button
                  v-on:click="getPricingOldest"
                  type="button"
                  block
                  variant="outline-primary"
                >Retrieve Latest Pricing for oldest-to-be-updated regions.</b-button>
                <br>
              </div>
              <div>
                <b-button
                  v-on:click="getPricingTest"
                  type="button"
                  v-b-tooltip.hover
                  title="Retrieve Latest Pricing for test regions."
                  block
                  variant="outline-primary"
                >Retrieve Latest Pricing for test regions.</b-button>
                <br>
              </div>
              <div>
                <b-button
                  v-on:click="getPricingAMER"
                  type="button"
                  v-b-tooltip.hover
                  title="Retrieve Latest Pricing for US."
                  block
                  variant="outline-primary"
                >Retrieve Latest Pricing for US.</b-button>
                <br>
              </div>
              <div>
                <b-button
                  v-on:click="getPricingEURO"
                  type="button"
                  block
                  variant="outline-primary"
                >Retrieve Latest Pricing for Europe.</b-button>
                <br>
              </div>
              <div>
                <b-button
                  v-on:click="getPricingCASA"
                  type="button"
                  block
                  variant="outline-primary"
                >Retrieve Latest Pricing for Canada and South America.</b-button>
                <br>
              </div>
              <div>
                <b-button
                  v-on:click="getPricingAPJ"
                  type="button"
                  block
                  variant="outline-primary"
                >Retrieve Latest Pricing for APJ.</b-button>
                <br>
              </div>
              <div>
                <b-button
                  v-on:click="getPricingAFME"
                  type="button"
                  block
                  variant="outline-primary"
                >Retrieve Latest Pricing for Africa and MiddleEast.</b-button>
                <br>
              </div>
              <div>
                <b-button
                  v-on:click="getPricingGOV"
                  type="button"
                  block
                  variant="outline-primary"
                >Retrieve Latest Pricing for Gov Cloud.</b-button>
                <br>
              </div>
  
 
              </div>
              

            </b-card-body>

        </b-card>
      </b-form>
    </div>
  </div>
</template>

<script>
import { Auth, API } from "aws-amplify";
import axios from "axios";

export default {
  name: "app",
  data() {
    return {
      user: '',
      showAlert: false,
      alertText: "",
      alertStyle: "default",
      alertTextRecalc: "",
      alertStyleRecalc: "default",
      showAlertRecalc: true,
      showCalculateMessageFlag: false,
      regionCode: "us-east-1",
      region_lov: [
{ value: 'af-south-1', text: 'af-south-1 Cape Town' },
{ value: 'ap-east-1', text: 'ap-east-1 Hong Kong'  },
{ value: 'ap-east-2', text: 'ap-east-2 Taipei'  },
{ value: 'ap-northeast-1', text: 'ap-northeast-1 Tokyo'  },
{ value: 'ap-northeast-2', text: 'ap-northeast-2 Seoul'  },
{ value: 'ap-northeast-3', text: 'ap-northeast-3 Osaka'  },
{ value: 'ap-south-1', text: 'ap-south-1 Mumbai'  },
{ value: 'ap-south-2', text: 'ap-south-2 Hyderabad'  },
{ value: 'ap-southeast-1', text: 'ap-southeast-1 Singapore'  },
{ value: 'ap-southeast-2', text: 'ap-southeast-2 Sydney'  },
{ value: 'ap-southeast-3', text: 'ap-southeast-3 Jakarta'  },
{ value: 'ap-southeast-4', text: 'ap-southeast-4 Melbourne'  },
{ value: 'ap-southeast-5', text: 'ap-southeast-5 Malaysia'  },
{ value: 'ap-southeast-6', text: 'ap-southeast-6 New Zealand'  },
{ value: 'ap-southeast-7', text: 'ap-southeast-7 Thailand'  },
{ value: 'ca-central-1', text: 'ca-central-1 Canada' },
{ value: 'ca-west-1', text: 'ca-west-1 Calgary' },
{ value: 'eu-central-1', text: 'eu-central-1 Frankfurt'  },
{ value: 'eu-central-2', text: 'eu-central-2 Zurich'  },
{ value: 'eu-north-1', text: 'eu-north-1 Stockholm'  },
{ value: 'eu-south-1', text: 'eu-south-1 Milan'  },
{ value: 'eu-south-2', text: 'eu-south-2 Spain'  },
{ value: 'eu-west-1', text: 'eu-west-1 Ireland' },
{ value: 'eu-west-2', text: 'eu-west-2 London'  },
{ value: 'eu-west-3', text: 'eu-west-3 Paris'  },
{ value: 'il-central-1', text: 'il-central-1 Tel Aviv'  },
{ value: 'me-central-1', text: 'me-central-1 UAE'  },
{ value: 'me-south-1', text: 'me-south-1 Bahrain'  },
{ value: 'mx-central-1', text: 'mx-central-1 Mexico'  },
{ value: 'sa-east-1', text: 'sa-east-1 Sao Paulo' },
{ value: 'us-east-1', text: 'us-east-1 N.Virginia' },
{ value: 'us-east-2', text: 'us-east-2 Ohio'  },
{ value: 'us-gov-east-1', text: 'us-gov-east-1 GovCloud US-East'  },
{ value: 'us-gov-west-1', text: 'us-gov-west-1 GovCloud US-West'  },
{ value: 'us-west-1', text: 'us-west-1 N.California'  },
{ value: 'us-west-2', text: 'us-west-2 Oregon'  }
      ]      
    };
  },
    async created() {    
    
    let name = await Auth.currentAuthenticatedUser();
    this.user = name.username;
    // console.log("authenticated", this.user, name);
    //if we need email, it can be found at name.attributes.email
    
    if ( (!["dbayardAWS","amzn~dbayard"].includes(this.user)) ) {
            console.log("Sorry, not authorized to view this page.  Routing back to main page.");      
            this.$router.push('/');
    }        

    },
  methods: {
    async getPricingOldest(evt) {
      //logic:
      //sort region_lov by parse(lastUpdate) descending
        function compareDates(a, b) {
          
          let comparison = 0;
          if (Date.parse(a.lastUpdate) > Date.parse(b.lastUpdate)) {
            comparison = 1;
          } else if (Date.parse(a.lastUpdate) < Date.parse(b.lastUpdate)) {
            comparison = -1;
          } else if (a.value > b.value) {
            // same lastUpdate - break the tie by region code descending (us-east-1 before eu-west-1)
            comparison = -1;
          } else if (a.value < b.value) {
            comparison = 1;
          }
          return comparison;
        }
     this.region_lov.sort(compareDates);
      
      //loop through 5 oldest
     for (var ii = 0; ii < Math.min(this.region_lov.length,5) ; ii++) {   
       var i = this.region_lov[ii];
       this.regionCode = i.value;
       await this.getPricing(evt, 'REGION');
       this.region_lov[ii].lastUpdate = new Date(Date.now()).toLocaleString('en-us', {dateStyle: "long"});
       this.region_lov[ii].text = this.region_lov[ii].origText + " - UPDATED";
     }   
    },
    
    async getPricingTest(evt) {
      this.regionCode = 'us-east-1';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'ca-central-1';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'sa-east-1';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'eu-west-1';
      await this.getPricing(evt, 'REGION');
    },
    async getPricingAMER(evt) {
      this.regionCode = 'us-east-1';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'us-east-2';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'us-west-1';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'us-west-2';
      await this.getPricing(evt, 'REGION');
    },
    async getPricingCASA(evt) {
      this.regionCode = 'sa-east-1';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'ca-central-1';
      await this.getPricing(evt, 'REGION');
    },
    async getPricingEURO(evt) {
      this.regionCode = 'eu-west-1';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'eu-west-2';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'eu-west-3';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'eu-north-1';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'eu-south-1';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'eu-central-1';
      await this.getPricing(evt, 'REGION');
    },
    async getPricingAPJ(evt) {
      this.regionCode = 'ap-east-1';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'ap-northeast-1';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'ap-northeast-2';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'ap-northeast-3';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'ap-south-1';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'ap-southeast-1';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'ap-southeast-2';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'ap-southeast-3';
      await this.getPricing(evt, 'REGION');
    },
    async getPricingAFME(evt) {
      this.regionCode = 'af-south-1';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'me-south-1';
      await this.getPricing(evt, 'REGION');
    },
    async getPricingGOV(evt) {
      this.regionCode = 'us-gov-east-1';
      await this.getPricing(evt, 'REGION');
      this.regionCode = 'us-gov-west-1';
      await this.getPricing(evt, 'REGION');
    },
    async getPricingRegion(evt) {
      await this.getPricing(evt, 'REGION');
    },
    
    
    async getPricing(evt, mode) {
      console.log("Retrieving prices for ", this.regionCode);
      evt.preventDefault();
      this.showCalculateMessageFlag = false;
      this.alertStyleRecalc="primary";
      this.alertTextRecalc = "Retrieving Pricing... Please wait...";
      this.showAlertRecalc = true;

     var myRdsItems=[];
    await axios
      .get("/shapes.json")
      .then(response => {
        // console.log("Loading shapes.json", myRdsItems, response.data.shapes);
        myRdsItems = response.data.shapes;

        // function rdsCompare(a, b) {
        //   // Use toUpperCase() to ignore character casing
        //   const itemA = (a.Oracle1yrNURI * 1 > 0 ? a.Oracle1yrNURI*1 : a.OracleOD*1) * 1000 + a.VCPU*1;
        //   const itemB = (b.Oracle1yrNURI * 1 > 0 ? b.Oracle1yrNURI*1 : b.OracleOD*1) * 1000 + b.VCPU*1;

        //   let comparison = 0;
        //   if (itemA > itemB) {
        //     comparison = 1;
        //   } else if (itemA < itemB) {
        //     comparison = -1;
        //   }
        //   return comparison;
        // }
        // myRdsItems.sort(rdsCompare);
        // this.rdsPrices = this.rdsItems;
      })
      .catch(error => {
        console.log("Batch-Load rds data Error:", error);
      });




     // get some general info
     var isSuccess = true;
     var tries = 5;
     
     var generalInfo = {};
        await API.get(
          "dbcsiAPI",
          `/dbcsi/price_instance/${this.regionCode}/General/general`
        )
          .then(response => {
  				// 	console.log("get price success "+response.success);
  					if (response.success) {
  					 // console.log("get General price data ",response.data);

  					  generalInfo = response.data;

  					} else {
  					  console.log("General Pricing Error:", this.regionCode, i.Name);
  					}
            
          })
          .catch(error => {
            console.log("General Pricing Error:", error);
            
          });         
     
     // for (var i of myRdsItems) {
     
     for (var ii = 0; ii < myRdsItems.length; ii++) {   
       var i = myRdsItems[ii];
       
      // debug toggle, real filters commented out below
       
      // eslint-disable-next-line no-constant-condition
      if (true) {
          // if (i.Name =="r6i.32xlarge") {
        // if (i.Name.includes('tpc')) {
        // if (i.Name.substring(0,3) =="r5.") {          
     
        // console.log("before", i, this.regionCode);
         
         
        this.alertTextRecalc = "Retrieving "+this.regionCode+" Prices for "+i.Name+ " [ "+ ii + " of " + myRdsItems.length + " ]";

        // due to throttling and timeouts, use a loop and multiple tries
        
        tries =5;
        
        while (tries > 0) {
          isSuccess = true;
          //don't fetch EC2 prices for graviton
          //if we see a g in the first 6 letters
          if (i.Name.substring(0,6).indexOf('g') == -1) {
            await API.get(
              "dbcsiAPI",
              `/dbcsi/price_instance/${this.regionCode}/AmazonEC2/${i.Name}`
            )
              .then(response => {
      				// 	console.log("get price success "+response.success);
      					if (response.success) {
      					 // console.log("get EC2 price data ",response.data);
    
      					  myRdsItems[ii].LinuxOD = response.data.LinuxOD;
      					  myRdsItems[ii].Linux1yrNURI = response.data.Linux1yrNURI;
      					  myRdsItems[ii].RHELOD = response.data.RHELOD;
      					  myRdsItems[ii].RHEL1yrNURI = response.data.RHEL1yrNURI;
    
      					} else {
    					    console.log("EC2 Pricing Error:", this.regionCode, i.Name, tries);
    					    isSuccess = false;
    					  }
                
              })
              .catch(error => {
                console.log("EC2 Pricing Error:", this.regionCode, i.Name, error, tries);
                isSuccess = false;
                
              });  
          }  else {
      					  myRdsItems[ii].LinuxOD = null;
      					  myRdsItems[ii].Linux1yrNURI = null;
      					  myRdsItems[ii].RHELOD = null;
      					  myRdsItems[ii].RHEL1yrNURI = null;
            
          }  

            if (isSuccess) {
              break;
            } else {
              tries--;
              // console.log("Retrying. Tries remaining", tries);
            }
         
          } //end while


//now do RDS
        tries =5;
        
        while (tries > 0) {
          isSuccess = true;
 
          await API.get(
            "dbcsiAPI",
            `/dbcsi/price_instance/${this.regionCode}/AmazonRDS/db.${i.Name}`
          )
            .then(response => {
    				// 	console.log("get price success "+response.success);
    					if (response.success) {
    					 // console.log("get RDS price data ",response.data);
  
    					  myRdsItems[ii].DBName = "db."+i.Name;
    					  myRdsItems[ii].OracleOD = response.data.OracleOD;
    					  myRdsItems[ii].Oracle1yrNURI = response.data.Oracle1yrNURI;
    					  myRdsItems[ii].OracleLIse2_OD = response.data.OracleLIse2_OD;
    					  myRdsItems[ii].OracleLIse2_1yrNURI = response.data.OracleLIse2_1yrNURI;
    					  myRdsItems[ii].OracleCustomOD = response.data.OracleCustomOD;
    					  myRdsItems[ii].OracleCustom1yrNURI = response.data.OracleCustom1yrNURI;
    					  myRdsItems[ii].AuroraPGOD = response.data.AuroraPGOD;
    					  myRdsItems[ii].AuroraPG1yrNURI = response.data.AuroraPG1yrNURI;
    					  myRdsItems[ii].AuroraPGOptimOD = response.data.AuroraPGOptimOD;
    					  myRdsItems[ii].AuroraPGOptim1yrNURI = response.data.AuroraPGOptim1yrNURI;
    					  myRdsItems[ii].Db2_OD = response.data.Db2_OD;
    					  myRdsItems[ii].Db2_1yrNURI = response.data.Db2_1yrNURI;
    					  
    					  // hack for savings plans
    					  // for now, just calculate cost.
    					  // in future, maybe use the savings plans price files: https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/finding-prices-in-service-price-list-files.html
    					  // you can not use the Price List Query API to see savings plans as of Dec-2025
    					  if (i.Name.startsWith("m7i") || i.Name.startsWith("r7i") || i.Name.startsWith("m8i") || i.Name.startsWith("r8i")
    					       || i.Name.startsWith("r7g") || i.Name.startsWith("r8g") || i.Name.startsWith("r8a")) {
    					       
    					    if (response.data.OracleOD!=null) {
    					      myRdsItems[ii].Oracle1yrNUSP = Math.round(10000 * response.data.OracleOD * 0.8) / 10000;
    					    } else {
    					      myRdsItems[ii].Oracle1yrNUSP = null;
    					    }
    					    if (response.data.AuroraPGOptimOD!=null) {
    					      myRdsItems[ii].AuroraPGOptim1yrNUSP = Math.round(10000 *response.data.AuroraPGOptimOD * 0.8) / 10000;
    					    } else {
    					      myRdsItems[ii].AuroraPGOptim1yrNUSP = null;
    					    }   
    					    if (response.data.AuroraPGOD!=null) {
    					      myRdsItems[ii].AuroraPG1yrNUSP = Math.round(10000 *response.data.AuroraPGOD * 0.8) / 10000;
    					    } else {
    					      myRdsItems[ii].AuroraPG1yrNUSP = null;
    					    } 
    					    if (response.data.Db2_OD!=null) {
    					      myRdsItems[ii].Db2_1yrNUSP = Math.round(10000 *response.data.Db2_OD * 0.8) / 10000;
    					    } else {
    					      myRdsItems[ii].Db2_1yrNUSP = null;
    					    } 
    					  }
    					  
    					  
    					} else {
    					  console.log("RDS Pricing Error:", this.regionCode, i.Name, tries);
    					  isSuccess = false;
    					}
              
            })
            .catch(error => {
              console.log("RDS Pricing Error:", this.regionCode, i.Name, error, tries);
              isSuccess = false;
              
            });    
            
            if (isSuccess) {
              break;
            } else {
              tries--;
              // console.log("Retrying. Tries remaining", tries);
            }
         
          } //end while


//now do Elasticache
        tries =5;
        
        while (tries > 0) {
          isSuccess = true;
 
          await API.get(
            "dbcsiAPI",
            `/dbcsi/price_instance/${this.regionCode}/AmazonElastiCache/cache.${i.Name}`
          )
            .then(response => {
    				// 	console.log("get price success "+response.success);
    					if (response.success) {
    					 
    					 
    					 //did we get data?
    					 if (response.data.ElasticacheOD*1 > 0 ) {
    					    if (response.data.ElasticacheMemory==undefined) {
    					      console.log("get Elasticache price data ",response.data);
    					    }  
  
      					  myRdsItems[ii].ElasticacheName = "cache."+i.Name;
      					  myRdsItems[ii].ElasticacheOD = response.data.ElasticacheOD;
      					  myRdsItems[ii].Elasticache1yrNURI = response.data.Elasticache1yrNURI;
      					  myRdsItems[ii].ElasticacheMemory = response.data.ElasticacheMemory;
      					  //remove the trailing "GiB" from the myRdsItems[ii].ElasticacheMemory string 
      					  if (myRdsItems[ii].ElasticacheMemory.indexOf(" GiB")>0) {
      					    myRdsItems[ii].ElasticacheMemory = myRdsItems[ii].ElasticacheMemory.substr(0,myRdsItems[ii].ElasticacheMemory.indexOf(" GiB"));
      					  }
      					  myRdsItems[ii].ElasticacheMemory = myRdsItems[ii].ElasticacheMemory *1;
      					  
    					 }  

    					  
    					} else {
    					  console.log("Elasticache Pricing Error:", this.regionCode, i.Name, tries, response.data);
    					  isSuccess = false;
    					}
              
            })
            .catch(error => {
              console.log("Elasticache Pricing Error:", this.regionCode, i.Name, error, tries);
              isSuccess = false;
              
            });    
            
            if (isSuccess) {
              break;
            } else {
              tries--;
              // console.log("Retrying. Tries remaining", tries);
            }
         
          } //end while
         
        }   
     }   
     
          this.alertTextRecalc = "Retrieving Prices Finished.";
          this.alertStyleRecalc="success";
    // var finalAnswer = {
    //   region: this.regionCode,
    //   lastUpdate: new Date(Date.now()).toLocaleString(),
    //   ec2_gp2_gb: "0.10",
    //   ec2_io1_gb: "0.12",
    //   ec2_io1_iops: "0.0625",
    //   ec2_gp3_gb: "0.08",
    //   ec2_gp3_iops: "0.005",
    //   ec2_gp3_thru: "0.06",
    //   ec2_io2_gb: "0.12",
    //   ec2_io2_iops1: "0.0625",
    //   ec2_io2_iops2: "0.046",
    //   ec2_io2_iops3: "0.032",
    //   rds_gp2_gb: "0.115",
    //   rds_io1_gb: "0.125",
    //   rds_io1_iops: "0.10",
    //   rds_backup_gb: "0.095",
    //   aurora_gb: "0.10",
    //   aurora_io: "0.20",
    //   aurora_backup: "0.021",
    //   shapes: myRdsItems
    // };
    // console.log("count-before", myRdsItems.length);
     var finalAnswer = generalInfo;
     //trim myRdsItems
     function usable(value) {
       //if we don't even have a linux or Oracle or Aurora price, then don't bother
       return (  value.LinuxOD || value.AuroraPGOD || value.OracleOD || value.ElasticacheOD );
     }
     finalAnswer.shapes = myRdsItems.filter(usable);
    // console.log("count-after", finalAnswer.shapes.length);
     
    // console.log("final answer",this.regionCode, finalAnswer.shapes.length, finalAnswer);
     
     
     //sanity check the answer
     //1.get matching db-region.json file
     //2.set the lastUpdate to be the same
     //3.do an equality check
    // now load Region info
    var success = true;
    var compareRegion = {};
      await axios
        .get("/db-"+this.regionCode+".json")
        .then(response => {
          // console.log("I am here4");
          compareRegion = response.data;
        
      })
        .catch(error => {
          // console.log("Pricing db-region.json data Error:", error);
          success = false;
      });
     if (success) {
       compareRegion.lastUpdate = finalAnswer.lastUpdate;
       let oldData = (JSON.stringify(compareRegion));
       let newData = (JSON.stringify(finalAnswer));
       
       var _ = require('lodash');
      // console.log("isEqual", _.isEqual(oldData, newData));
       
       var deepDiffMapper = function () {
  return {
    VALUE_CREATED: 'created',
    VALUE_UPDATED: 'updated',
    VALUE_DELETED: 'deleted',
    VALUE_UNCHANGED: 'unchanged',
    map: function(obj1, obj2) {
      if (this.isFunction(obj1) || this.isFunction(obj2)) {
        throw 'Invalid argument. Function given, object expected.';
      }
      if (this.isValue(obj1) || this.isValue(obj2)) {
        
        return {
          type: this.compareValues(obj1, obj2),
          data: obj1 === undefined ? obj2 : obj1
        };
        

      }

      var diff = {};
      for (var key in obj1) {
        if (this.isFunction(obj1[key])) {
          continue;
        }

        var value2 = undefined;
        if (obj2[key] !== undefined) {
          value2 = obj2[key];
        }

        diff[key] = this.map(obj1[key], value2);
      }
      for (var key in obj2) {
        if (this.isFunction(obj2[key]) || diff[key] !== undefined) {
          continue;
        }

        diff[key] = this.map(undefined, obj2[key]);
      }

      return diff;

    },
    compareValues: function (value1, value2) {
      if (value1 === value2) {
        return this.VALUE_UNCHANGED;
      }
      if (this.isDate(value1) && this.isDate(value2) && value1.getTime() === value2.getTime()) {
        return this.VALUE_UNCHANGED;
      }
      if (value1 === undefined) {
        return this.VALUE_CREATED;
      }
      if (value2 === undefined) {
        return this.VALUE_DELETED;
      }
      return this.VALUE_UPDATED;
    },
    isFunction: function (x) {
      return Object.prototype.toString.call(x) === '[object Function]';
    },
    isArray: function (x) {
      return Object.prototype.toString.call(x) === '[object Array]';
    },
    isDate: function (x) {
      return Object.prototype.toString.call(x) === '[object Date]';
    },
    isObject: function (x) {
      return Object.prototype.toString.call(x) === '[object Object]';
    },
    isValue: function (x) {
      return !this.isObject(x) && !this.isArray(x);
    }
  }
}();
// https://stackoverflow.com/questions/8572826/generic-deep-diff-between-two-objects

var result = deepDiffMapper.map(JSON.parse(oldData), JSON.parse(newData));
//delete top level unchanged
Object.keys(result).forEach(key => {
  if (result[key].type=="unchanged") delete result[key];
});
// var myshapes=[];
// //delete shapes unchanged
// for (var shape in result.shapes) {
//   var foundOne=false;
//   // console.log("shape", shape)
//   Object.keys(result.shapes[shape]).forEach(key => {
//     // console.log("key", key, result.shapes[shape][key])
//     if (key!="Name" && result.shapes[shape][key].type!="unchanged") {
//       foundOne=true;
//       // console.log("change", result.shapes[shape][key])
//     }  
//   });

//   if (foundOne ) {
//     // console.log("push", result.shapes[shape])
//     myshapes.push(result.shapes[shape]);
//   }  
// }
// result.shapes=myshapes;
result.shapes=[];
// console.log("Differences?", result);

// TODO: need a better diff.  the above fails for shapes[] when something is added because you can't compare shapes[N] to shapes[N] anymore
// essentially, we need to loop through shapes[] and look for a matching shapes with Name=Name.  Then we need to compare all the properties of Shapes[x] and shapes[y]
// for shape in newShapes
//.  lookup oldShape in OldShapes where OldShapes[?].Name == newShapes[shape].Name.  If no match, push
//.     is _.isEqual( oldShapes[oldShape] , newShapes[shape]
//          if not.. push

var newshapes = [];
var changedshapes = [];
for (var newshape in finalAnswer.shapes) {
  var oldshape = compareRegion.shapes.find((element) => element.Name == finalAnswer.shapes[newshape].Name);
  if (oldshape) {
    if ( ! _.isEqual(oldshape, finalAnswer.shapes[newshape])) {
      changedshapes.push(finalAnswer.shapes[newshape]);
    }
  } else {
    newshapes.push(finalAnswer.shapes[newshape]);
  }
}

// var diff2 = function (a,b) {
//     var r = {};
//     _.each(a, function(v,k) {
//         if(b[k] === v) return;
//         // but what if it returns an empty object? still attach?
//         r[k] = _.isObject(v)
//                 ? _.diff2(v, b[k])
//                 : v
//             ;
//         });
//     return r;
// }
// https://stackoverflow.com/questions/8572826/generic-deep-diff-between-two-objects
// console.log("result2",diff2( JSON.parse(newData), JSON.parse(oldData)) );


       if (oldData==newData) {
         console.log("are they the same? YES", this.regionCode);
       } else {
         console.log("are they the same? NO.  old,new: ", this.regionCode, compareRegion.shapes.length,finalAnswer.shapes.length);
         console.log("new shapes", newshapes);
         console.log("changed shapes", changedshapes);
         console.log("final answer",this.regionCode, finalAnswer.shapes.length, finalAnswer);
        // console.log("old",oldData);
        // console.log("new",newData);
       }   
       
     }   else {
       console.log("new region",this.regionCode, finalAnswer.shapes.length, finalAnswer);
     }
     
    },
    
    async getShapeAttributes(evt, mode) {
      console.log("Getting Shape Attributes");
      evt.preventDefault();
      this.showCalculateMessageFlag = false;
      this.alertStyleRecalc="primary";
      this.alertTextRecalc = "Retrieving Shape Attributes... Please wait...";
      this.showAlertRecalc = true;

     var myRdsItems=[];
    await axios
      .get("/shapes.json")
      .then(response => {
        // console.log("Loading shapes.json", myRdsItems, response.data.shapes);
        myRdsItems = response.data.shapes;

      })
      .catch(error => {
        console.log("Pricing-Load shapes Error:", error);
      });


     var isSuccess = true;
     var tries = 5;
     var newShapes = JSON.parse(JSON.stringify(myRdsItems));
     
     for (var ii = 0; ii < myRdsItems.length; ii++) {   
       var i = myRdsItems[ii];
       

        if ( !(i.Name.includes('tpc')) && !(i.Name.includes('x2g.'))  ) {   
        // if ( !(i.Name.includes('tpc')) && (i.Name =="c6i.2xlarge") ) {      
        // if ( !(i.Name.includes('tpc')) && !(i.Name.includes('x2g.')) && (i.Name.substring(0,1) =="i") ) {          
     
        // console.log("before", i, this.regionCode);
         
         
        this.alertTextRecalc = "Retrieving Attributes for "+i.Name+ " [ "+ ii + " of " + myRdsItems.length + " ]";

        // due to throttling and timeouts, use a loop and multiple tries
        
        tries =2;
        
        while (tries > 0) {
          isSuccess = true;
          
            await API.get(
              "dbcsiAPI",
              `/dbcsi/shape_attributes/us-east-1/AmazonEC2/${i.Name}`
            )
              .then(response => {
      				 	// console.log("get attributes success "+response.success);
      					if (response.success) {
      					 // console.log("get EC2 attributes data ",response.data);
      					  var refinedInfo = {
		"Name" : response.data.InstanceTypes[0].InstanceType,
		"VCPU" : response.data.InstanceTypes[0].VCpuInfo.DefaultVCpus,
		"Memory" : Math.round(response.data.InstanceTypes[0].MemoryInfo.SizeInMiB/1024),
		"Throughput" : response.data.InstanceTypes[0].EbsInfo.EbsOptimizedInfo.MaximumThroughputInMBps,
		"BaselineThroughput" : (Math.abs(response.data.InstanceTypes[0].EbsInfo.EbsOptimizedInfo.MaximumThroughputInMBps - response.data.InstanceTypes[0].EbsInfo.EbsOptimizedInfo.BaselineThroughputInMBps) <= 20) ? null : response.data.InstanceTypes[0].EbsInfo.EbsOptimizedInfo.BaselineThroughputInMBps,
		"IOPS" : response.data.InstanceTypes[0].EbsInfo.EbsOptimizedInfo.MaximumIops,
		"BaselineIOPS" : (Math.abs(response.data.InstanceTypes[0].EbsInfo.EbsOptimizedInfo.MaximumIops - response.data.InstanceTypes[0].EbsInfo.EbsOptimizedInfo.BaselineIops) <= 20) ? null : response.data.InstanceTypes[0].EbsInfo.EbsOptimizedInfo.BaselineIops,
		"Network" : response.data.InstanceTypes[0].NetworkInfo.NetworkPerformance,
		"BaselineNetwork" : (response.data.InstanceTypes[0].NetworkInfo.NetworkCards) ? Math.round((/^(r6in|m6in|r6idn|m6idn)\./.test(response.data.InstanceTypes[0].InstanceType) ? response.data.InstanceTypes[0].NetworkInfo.NetworkCards[0].BaselineBandwidthInGbps || 0 : response.data.InstanceTypes[0].NetworkInfo.NetworkCards.reduce((sum, c) => sum + (c.BaselineBandwidthInGbps || 0), 0)) * 1000) : null
      					    
      					  };
      					  if (refinedInfo.Network.indexOf("Up to ")>=0) {
      					    //strip Gigabit from string
      					    refinedInfo.Network = refinedInfo.Network.substr(6);
      					    //if the real data doesn't define the baselineNetwork, then put a place holder
      					    // if (i.BaselineNetwork==null) {
      					    //   refinedInfo.BaselineNetwork=1;
      					    //   console.log(i.Name, "Missing network baseline info - https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/compute-optimized-instances.html");
      					    // }
      					  }
      					  
      					  if (refinedInfo.Network.indexOf(" Gigabit")>0) {
      					    //strip Gigabit from string
      					    refinedInfo.Network = refinedInfo.Network.substr(0, refinedInfo.Network.indexOf(" Gigabit")) * 1000;
      					  }
      					  // if BaselineNetwork approximately equals Network, set to null (non-burstable)
      					  if (refinedInfo.BaselineNetwork != null && Math.abs(refinedInfo.BaselineNetwork - refinedInfo.Network) <= 20) {
      					    refinedInfo.BaselineNetwork = null;
      					  }
      					 // console.log("refined info", refinedInfo);
    
                  //now compare to real
                  if ( (i.VCPU*1 != refinedInfo.VCPU *1) ||
                       (i.Memory*1 != refinedInfo.Memory *1) ||
                       (i.Throughput*1 != refinedInfo.Throughput *1) ||
                       (i.BaselineThroughput*1 != refinedInfo.BaselineThroughput *1) ||
                       (i.IOPS*1 != refinedInfo.IOPS *1) ||
                       (i.BaselineIOPS*1 != refinedInfo.BaselineIOPS *1) ||
                       (Math.abs(i.Network*1 - refinedInfo.Network*1) > 20) ||
                       ( (Math.abs(i.BaselineNetwork*1 - refinedInfo.BaselineNetwork*1) > 20) && (refinedInfo.BaselineNetwork!=null) ) ) 
                    {
                         console.log("Not the same", i, refinedInfo);
                         newShapes[ii].VCPU = refinedInfo.VCPU;
                         newShapes[ii].Memory = refinedInfo.Memory;
                         newShapes[ii].Throughput = refinedInfo.Throughput;
                         newShapes[ii].BaselineThroughput = refinedInfo.BaselineThroughput;
                         newShapes[ii].IOPS = refinedInfo.IOPS;
                         newShapes[ii].BaselineIOPS = refinedInfo.BaselineIOPS;
                         newShapes[ii].Network = refinedInfo.Network;
                         if (refinedInfo.BaselineNetwork!=null) newShapes[ii].BaselineNetwork = refinedInfo.BaselineNetwork;
                         
                    }
      					 
    
      					} else {
    					    console.log("EC2 Attributes Error:", this.regionCode, i.Name, tries);
    					    isSuccess = false;
    					  }
                
              })
              .catch(error => {
                console.log("EC2 Attributes Error:", this.regionCode, i.Name, error, tries);
                isSuccess = false;
                
              });  
          

            if (isSuccess) {
              break;
            } else {
              tries--;
              // console.log("Retrying. Tries remaining", tries);
            }
         
          } //end while




         
        }   
       
     }
          this.alertTextRecalc = "Retrieving Attributes Finished.";
          this.alertStyleRecalc="success";

     console.log("updated shapes", { shapes: newShapes } );
     
     
    },
    
    async scanDates(evt) {
      
        evt.preventDefault();
        this.showCalculateMessageFlag = false;
        this.alertStyleRecalc="primary";
        this.alertTextRecalc = "Scanning Last Update Dates... Please wait...";
        this.showAlertRecalc = true;

       var success = true;
       var tries = 5;
       
       for (var ii = 0; ii < this.region_lov.length; ii++) {   
         var i = this.region_lov[ii];
         
  
           
          this.alertTextRecalc = "Retrieving "+i.value+"  [ "+ ii + " of " + this.region_lov.length + " ]";
  
          var compareRegion = {};
          success = true;
          
          await axios
            .get("/db-"+i.value+".json")
            .then(response => {
              // console.log("I am here4");
              compareRegion = response.data;
            
          })
            .catch(error => {
              // console.log("Pricing db-region.json data Error:", error);
              success = false;
          });
          
          if (success) {
            // console.log("dates", compareRegion.lastUpdate, Date.parse(compareRegion.lastUpdate));
            this.region_lov[ii].lastUpdate = compareRegion.lastUpdate;
            if (this.region_lov[ii].origText==undefined) {
              this.region_lov[ii].origText = this.region_lov[ii].text;
            }
            this.region_lov[ii].text = this.region_lov[ii].origText + " - "+ this.region_lov[ii].lastUpdate;
          } else {
            this.region_lov[ii].lastUpdate = "January 1, 2020";
            if (this.region_lov[ii].origText==undefined) {
              this.region_lov[ii].origText = this.region_lov[ii].text;
            }
            this.region_lov[ii].text = this.region_lov[ii].origText + " - "+ this.region_lov[ii].lastUpdate;
            
          }
  
  
       }   
     
        this.alertTextRecalc = "Scanning Dates Finished.";
        this.alertStyleRecalc="success";

     

     
    },


    onReset(evt) {
      evt.preventDefault();
    }
  }
};
</script>

<style>
</style>
